import { useState } from 'react';
import { useMinistryTeamStore } from '../../../../../store/ministryTeamStore';
import { createMinistryTeam, getMinistryTeams } from '../apis/ministryTeam-apis';
import { MinistryTeam } from '../types/ministryTeam';

/**
 * 사역팀 추가 관련 로직을 관리하는 커스텀 훅
 */
export const useAddMinistryTeam = () => {
  const { setMinistryTeams } = useMinistryTeamStore();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>('');

  /**
   * 사역팀 추가 및 DB 동기화
   * @param ministryTeam 추가할 사역팀 데이터
   * @param onSuccess 추가 성공 시 호출할 콜백 (폼 초기화 등)
   */
  const addMinistryTeam = async (ministryTeam: MinistryTeam, onSuccess?: () => void) => {
    if (isLoading) return;

    setIsLoading(true);
    setError('');

    try {
      // DB에 사역팀 추가
      await createMinistryTeam(ministryTeam);

      // DB에서 최신 리스트 가져오기
      const updatedMinistryTeams = await getMinistryTeams();

      // 스토어 업데이트
      setMinistryTeams(updatedMinistryTeams);

      // 성공 콜백 실행 (폼 초기화 등)
      onSuccess?.();
    } catch (err) {
      const errorMessage = '사역팀 추가 중 오류가 발생했습니다. 다시 시도해주세요.';
      console.error('사역팀 추가 중 오류 발생:', err);
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addMinistryTeam,
    isLoading,
    error,
    clearError: () => setError(''),
  };
};

